<template>
	<div class="carousel-wrapper">
		<HomeNavigation/>
		<div v-if="!isNavToggled" class="text-container">
			<h1>Prirodni</h1>
			<p>Proizvodi za negu vašeg lica i tela</p>
			<router-link to="/shop/body">
				<button style="margin-bottom: 100px">Poručite</button>
			</router-link>
		</div>
		<transition name="component-fade" >
			<SlideComponent class="slide" :image-name="currentSlideName" :key="activeSlide"/>
		</transition>
	</div>
</template>

<script>
	import SlideComponent from "@/component/user/home/carousel/SlideComponent";
	import HomeNavigation from "@/component/user/home/HomeNavigation";
    import {mapGetters} from 'vuex'

	export default {
		name: "CarouselComponent",
		components: {
			SlideComponent,
			HomeNavigation
		},
		data() {
			return {
				slides: [
					{
						name: 'carousel-1.jpg'
					},
					{
						name: 'carousel-2.jpg'
					}
				],
				activeSlide: 0
			}
		},
		computed: {
            ...mapGetters([
                'isNavToggled'
            ]),

			numberOfSlides() {
				return this.slides.length - 1
			},

			currentSlideName() {
				return this.slides[this.activeSlide].name
			}
		},
		created() {
			setInterval(() => {
				if (this.activeSlide < this.numberOfSlides) {
					this.activeSlide++
				} else {
					this.activeSlide = 0
				}
			}, 5000)
		}
	}
</script>

<style scoped>
    .text-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: absolute;
        margin-left: 30%;
        width: 70%;
        height: 100%;
        z-index: 5 !important;
    }

    h1 {
        color: #F0EAD6;
        font-size: 3.5vw;
        font-weight: bold;
        font-family: Poppins, serif;
        text-decoration: none;
        user-select: none;
    }

    p {
        font-size: 1.5vw;
        color: #F0EAD6;
        text-decoration: none;
        user-select: none;
    }

    button {
        background: transparent;
        color: #F0EAD6;
        font-size: 1.5vw;
        padding: 15px;
        border: 3px solid #F0EAD6;
        border-radius: 40px;
        cursor: pointer;
    }

    .carousel-wrapper {
        position: relative;
        max-height: 100vh;
        height: 100vh;
    }

    .slide {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        max-height: 100%;
        height: 100%;
        overflow: hidden;
    }

    @media only screen and (max-width: 600px) {
        .text-container {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 100%;
            height: 100%;
            margin: 0;
            z-index: 5 !important;
        }

        h1 {
            font-size: 50px;
        }

        p {
            font-size: 18px;
        }

        button {
            font-size: 18px;
        }
    }

    @media only screen and (max-width: 1000px) {
        .text-container {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 100%;
            height: 100%;
            margin: 0;
            z-index: 5 !important;
        }

        h1 {
            font-size: 50px;
        }

        p {
            font-size: 18px;
        }

        button {
            font-size: 18px;
        }
    }

    @media only screen and (min-width: 1200px) {
        .text-container {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            position: absolute;
            margin-left: 30%;
            width: 70%;
            height: 100%;
            z-index: 5 !important;
        }

        h1 {
            font-size: 3.5vw;
        }

        p {
            font-size: 1.5vw;
        }

        button {
            font-size: 1.5vw;
        }
    }

	.component-fade-enter-active,
	.component-fade-leave-active {
		transition: opacity 0.7s ease-in-out;
	}

	.component-fade-enter,
	.component-fade-leave-to {
		opacity: 0.4;
	}
</style>